getCart().then(cart => {
  getCartProducts(cart).then(products => updateCart(cart, products));
})

/**
 *
 * @param cart
 * @param products
 */
function updateCart(cart, products) {
  const unavailableItems = cart.items.filter(i => !!i.product.variants.find(v => v.id === i.variant_id && !v.available));
  unavailableItems.map(i =>
    query('/cart/change.js', { id: i.key, quantity: 0 }, 'POST')
      .then(() => {
        document.dispatchEvent(new Event('cartItemRemoved')); // Dispatch event after successful removal
        console.log('Item removed, updating cart...');
      })
      .catch(error => console.error('Error removing item:', error)) // Handle errors properly
  );
  products.filter(i => !i.product).map(i => query('/cart/change.js', {
    id: i.key,
    quantity: i.quantity,
  }, 'POST').then().catch())
}

/**
 *
 * @param cart
 * @returns {Promise<unknown>}
 */
function getCartProducts(cart) {
  return new Promise(resolve => {
    const products = []
    cart.items.map((i, index) => {
      this.getProduct(i.product.handle).then(response => {
        products.push({ key: i.key, quantity: i.quantity, product: response.product })
        if (index + 1 === cart.items?.length) {
          resolve(products)
        }
      }).catch(() => {
        products.push({ key: i.key, quantity: i.quantity, product: null })
        if (index + 1 === cart.items?.length) {
          resolve(products)
        }
      })
    })
  })
}

/**
 *
 * @returns {Promise<unknown>}
 */
function getCart() {
  return new Promise((resolve, reject) => {
    query('/cart?view=es-cart').then(v => resolve(v)).catch(e => reject(e))
  })
}

/**
 *
 * @returns {Promise<unknown>}
 */
function getProduct(handle) {
  return new Promise((resolve, reject) => {
    query(`/products/${handle}.json`).then(v => resolve(v)).catch(e => reject(e))
  })
}

/**
 *
 * @param url
 * @param body
 * @param method
 * @returns {Promise<unknown>}
 */
function query(url, body = {}, method = 'GET') {
  return new Promise((resolve, reject) => {
    let params = { method }

    if (method === 'POST') {
      params['headers'] = { 'Content-Type': 'application/json' }
      params['body'] = JSON.stringify(body)
    }
    fetch(url, params).then(response => {
      if (response.ok) {
        response.json().then(i => resolve(i)).catch(e => reject(e))
      } else {
        reject({ error: response.statusText, status: response.status })
      }
    }).catch(e => reject(e))
  })
}
